
export const fetchNextPageAction = action => async ({ dispatch, getters }) => {
  const { page, perPage, search } = getters.getPagination;

  return dispatch(action, {
    page: page + 1,
    perPage,
    search
  });
}
